import { PredefinedCommentFormValidity } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.model';
import React from 'react';

export interface PredefinedCommentValidationContextType {
    validity: PredefinedCommentFormValidity;
    handleError: (
        field: keyof PredefinedCommentFormValidity,
        newValidity: PredefinedCommentFormValidity[keyof PredefinedCommentFormValidity]
    ) => void;
    setApiErrors: (errors: PredefinedCommentFormValidity) => void;
}

export const PredefinedCommentValidationContext = React.createContext<
    PredefinedCommentValidationContextType | undefined
>(undefined);
